<template lang="pug">
  #synthesis
    v-container.no-p(fluid)
      v-form
        v-layout(row wrap)
          v-flex#top(xs6)
            h1.form-title2.pink-text Síntesis de la asesoría
        v-layout.py-1.mt-3(row wrap align-end justify-space-between)
          v-flex.pr-2(d-flex xs6)
            v-text-field(
              v-model="country"
              ref="País"
              label="País"
              menu-props="auto"
            )
            //v-icon.visible(v-if="stateVisible" @click="visible('country')") visibility
            //v-icon.visible(v-if="!stateVisible" @click="visible('country')") visibility_off
          v-flex.pl-2(d-flex xs6)
            v-text-field(
              v-model="state"
              ref="Estado"
              label="Estado"
              menu-props="auto"
            )
            v-icon.visible(v-if="stateVisible" @click="visible('state')") visibility
            v-icon.visible(v-if="!stateVisible" @click="visible('state')") visibility_off
          v-flex(d-flex xs12)
            v-text-field(
              v-model="municipality"
              ref="Municipio"
              label="Municipio"
              menu-props="auto"
            )
            v-icon.visible(v-if="municipalityVisible" @click="visible('municipality')") visibility
            v-icon.visible(v-if="!municipalityVisible" @click="visible('municipality')") visibility_off

        v-layout.checkbox-title(row wrap align-end justify-space-between)
          v-flex.adjunct-label
            p Asunto de la asesoría
            v-tooltip(top close-delay=1000)
              v-icon.ml-1(slot="activator") info
              span.adjunct
                p Si tienes duda en como registrar los datos de "asunto de la asesoría",
                p.m-0 no te olvides de revisar el anexo de definiciones operativas.
                a(href="/static/documents/Atencion_Ax4_Asesoria_Temas_1_160722.pdf" target="_blank") Ir al documento
          v-icon.visible(v-if="matterVisible" @click="visible('matter')") visibility
          v-icon.visible(v-if="!matterVisible" @click="visible('matter')") visibility_off
        v-layout.py-1.mt-3(row wrap align-end justify-space-between)
          v-flex.pr-2.top-col.checkboxes(xs6)
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Administrativo"
                value="administrative"
                hide-details
                slot="activator"
              )
              span Administrativo
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Agrario"
                value="agrarian"
                hide-details
                slot="activator"
              )
              span Agrario
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Ambiental"
                value="environmental"
                hide-details
                slot="activator"
              )
              span Ambiental
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Civil"
                value="civil"
                hide-details
                slot="activator"
              )
              span Civil
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Derechos humanos"
                value="humanRights"
                hide-details
                slot="activator"
              )
              span Derechos humanos
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Familiar"
                value="family"
                hide-details
                slot="activator"
              )
              span Familiar
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Laboral"
                value="labor"
                hide-details
                slot="activator"
              )
              span Laboral
          v-flex.pr-2.top-col.checkboxes(xs6)
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Mercantil"
                value="trade"
                hide-details
                slot="activator"
              )
              span Mercantil
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Otro"
                value="other"
                hide-details
                slot="activator"
              )
              span Otro
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Migración"
                value="migration"
                hide-details
                slot="activator"
              )
              span Migración
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Penal"
                value="penal"
                hide-details
                slot="activator"
              )
              span Penal
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Salud"
                value="health"
                hide-details
                slot="activator"
              )
              span Salud
            v-tooltip(left)
              v-checkbox(
                v-model="matter"
                label="Violencia contra la mujer"
                value="womenViolence"
                hide-details
                slot="activator"
              )
              span Violencia contra la mujer

        v-layout.checkbox-title(row wrap align-end v-if="showOtherMatter")
          v-flex.pr-2.top-col(xs6)
            v-text-field(
              v-model="otherMatter"
              label="Especificar"
              :value="otherMatter"
            )

        v-layout.checkbox-title(row wrap align-end justify-space-between v-if="showProject")
          v-flex.adjunct-label
            p Proyecto del caso
            //v-tooltip(top close-delay=1000)
            //  v-icon.ml-1(slot="activator") info
            //  span.adjunct
            //    p Anexo: 
            //    a(href="http://frayjuandelarios.datacivica.org/" target="_blank") http://frayjuandelarios.datacivica.org/
        v-layout.py-1.mt-3(row wrap align-end justify-space-between v-if="showProject")
          v-flex.pr-2.top-col.checkboxes(xs6)
            v-tooltip(left)
              v-checkbox(
                v-model="project"
                label="Desaparecidos en Coahuila"
                value="coahuila"
                hide-details
                slot="activator"
              )
              span Desaparecidos en Coahuila
            v-tooltip(left)
              v-checkbox(
                v-model="project"
                label="Otras VDH"
                value="vdh"
                hide-details
                slot="activator"
              )
              span Otras VDH
          v-flex.pr-2.top-col.checkboxes(xs6)
            v-tooltip(left)
              v-checkbox(
                v-model="project"
                label="Desaparecidos en otros estados"
                value="otherStates"
                hide-details
                slot="activator"
              )
              span Desaparecidos en otros estados 

        v-layout.checkbox-title(row wrap align-end justify-space-between)
          v-flex.adjunct-label
            p Intervención
            v-tooltip(top close-delay=1000)
              v-icon.ml-1(slot="activator") info
              span.adjunct
                p Si tienes duda en como registrar los datos de "intervención",
                p.m-0 no te olvides de revisar la página 4 del procedimiento general.
                a(href="/static/documents/Atencion_Ax1_Atencion_Procedimiento_210727.pdf" target="_blank") Ir al documento
          v-icon.visible(v-if="interventionVisible" @click="visible('intervention')") visibility
          v-icon.visible(v-if="!interventionVisible" @click="visible('intervention')") visibility_off
        v-layout.py-1.mt-3.checkboxes(row wrap align-end justify-space-between)
          v-checkbox(
            v-model="intervention"
            label="Asesoría"
            value="advisory"
            hide-details
          )
          v-checkbox(
            v-model="intervention"
            label="Gestión"
            value="management"
            hide-details
          )
          v-checkbox(
            v-model="intervention"
            label="Canalización"
            value="canalization"
            hide-details
          )

        v-layout.checkbox-title(row wrap align-end justify-space-between)
          v-flex.adjunct-label
            p A donde se refirió a la persona interesada:
            v-tooltip(top close-delay=1000)
              v-icon.ml-1(slot="activator") info
              span.adjunct
                p Si tienes duda en como registrar los datos de "canalización",
                p.m-0 no te olvides de revisar la página 4 del procedimiento general.
                a(href="/static/documents/Atencion_Ax1_Atencion_Procedimiento_210727.pdf" target="_blank") Ir al documento
          v-icon.visible(v-if="referredVisible" @click="visible('referred')") visibility
          v-icon.visible(v-if="!referredVisible" @click="visible('referred')") visibility_off
        v-layout.py-1.mt-3.checkboxes(row wrap align-end justify-space-between)
          v-flex.pr-2.top-col.checkboxes(xs6)
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="AMP estatal"
                value="ampestatal"
                hide-details
                slot="activator"
              )
              span AMP estatal
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="AMP federal"
                value="ampfederal"
                hide-details
                slot="activator"
              )
              span AMP federal
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="CEAV Coahuila"
                value="ceavco"
                hide-details
                slot="activator"
              )
              span CEAV Coahuila
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="CEDH Estado"
                value="cedh"
                hide-details
                slot="activator"
              )
              span CEDH Estado
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Dependencia estatal"
                value="estatal"
                hide-details
                slot="activator"
              )
              span Dependencia estatal
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Obispado"
                value="obispado"
                hide-details
                slot="activator"
              )
              span Obispado
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Poder judicial federal"
                value="pjf"
                hide-details
                slot="activator"
              )
              span Poder judicial federal
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="CEDHC"
                value="cedhc"
                hide-details
                slot="activator"
              )
              span CEDHC
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="CNDH"
                value="cndh"
                hide-details
                slot="activator"
              )
              span CNDH
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Conciliación y arbitraje"
                value="conciliacion"
                hide-details
                slot="activator"
              )
              span Conciliación y arbitraje
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Defensoría jurídica"
                value="defensoria"
                hide-details
                slot="activator"
              )
              span Defensoría jurídica
          v-flex.pr-2.top-col.checkboxes(xs6)
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Mecanismo de defensores"
                value="defenders"
                hide-details
                slot="activator"
              )
              span Mecanismo de defensores
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="ONG/OSC"
                value="ongosc"
                hide-details
                slot="activator"
              )
              span ONG/OSC
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Dependencia federal"
                value="federal"
                hide-details
                slot="activator"
              )
              span Dependencia federal
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Dependencia municipal"
                value="municipal"
                hide-details
                slot="activator"
              )
              span Dependencia municipal
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Inst. Seg. Social"
                value="segsocial"
                hide-details
                slot="activator"
              )
              span Inst. Seg. Social
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Institución financiera"
                value="intfin"
                hide-details
                slot="activator"
              )
              span Institución financiera
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Lugar donde trabaja"
                value="work"
                hide-details
                slot="activator"
              )
              span Lugar donde trabaja
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Procuraduría especializada"
                value="procuraduria"
                hide-details
                slot="activator"
              )
              span Procuraduría especializada
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Profesional privado"
                value="private"
                hide-details
                slot="activator"
              )
              span Profesional privado
            v-tooltip(left)
              v-checkbox(
                v-model="referred"
                label="Otro"
                value="other"
                hide-details
                slot="activator"
              )
              span Otro

        v-layout.checkbox-title(row wrap align-end v-if="showOtherReferrence")
          v-flex.pr-2.top-col(xs6)
            v-text-field(
              v-model="otherReferrence"
              label="Especificar"
              :value="otherReferrence"
            )

        v-layout.checkbox-title(row wrap align-end justify-space-between)
          v-text-field(
            v-model="management"
            label="Gestión"
            :value="management"
            multi-line
          )
          
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
export default {
  name: "Synthesis",
  props: {},
  data() {
    return {
      folio: this.$store.state.record.folio,
      ageOptions: ["S/D"].concat([...Array(100).keys()].slice(1)),
      time: null,
      endTime: null,
      showProject: false,
      showOtherMatter: false,
      showOtherReferrence: false
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    options() {
      return this.$store.getters.options;
    },
    country: {
      get() {
        return this.$store.state.record.synthesis.country;
      },
      set(value) {
        this.$store.commit("updateCountry", value);
      }
    },
    countryVisible: {
      get() {
        return this.$store.state.record.synthesis.countryVisible;
      },
      set(value) {
        this.$store.commit("updateCountryVisible", value);
      }
    },
    state: {
      get() {
        return this.$store.state.record.synthesis.state;
      },
      set(value) {
        this.$store.commit("updateState", value);
      }
    },
    stateVisible: {
      get() {
        return this.$store.state.record.synthesis.stateVisible;
      },
      set(value) {
        this.$store.commit("updateStateVisible", value);
      }
    },
    municipality: {
      get() {
        return this.$store.state.record.synthesis.municipality;
      },
      set(value) {
        this.$store.commit("updateMunicipality", value);
      }
    },
    municipalityVisible: {
      get() {
        return this.$store.state.record.synthesis.municipalityVisible;
      },
      set(value) {
        this.$store.commit("updateMunicipalityVisible", value);
      }
    },
    matter: {
      get() {
        let matters = [];
        Object.entries(this.$store.state.record.synthesis.matter).forEach(
          entry => {
            if (entry[1].isSelected) {
              matters.push(entry[0]);
            }
          }
        );

        if (matters.indexOf("humanRights") !== -1) {
          this.showProject = true;
        } else {
          this.showProject = false;
          this.$store.commit("showVictimForm", false);
        }

        this.showOtherMatter = matters.includes("other") ? true : false;

        return matters;
      },
      set(value) {
        if (value.indexOf("other") === -1) {
          this.$store.commit("updateOtherMatter", "");
        }
        this.$store.commit("updateMatter", value);
      }
    },
    matterVisible: {
      get() {
        return this.$store.state.record.synthesis.matterVisible;
      },
      set(value) {
        this.$store.commit("updateMatterVisible", value);
      }
    },
    otherMatter: {
      get() {
        return this.$store.state.record.synthesis.otherMatter;
      },
      set(value) {
        this.$store.commit("updateOtherMatter", value);
      }
    },
    project: {
      get() {
        let projects = [];
        Object.entries(this.$store.state.record.synthesis.project).forEach(
          entry => {
            if (entry[1].isSelected) {
              projects.push(entry[0]);
            }
          }
        );
        if (
          projects.indexOf("coahuila") !== -1 ||
          projects.indexOf("otherStates") !== -1
        ) {
          this.$store.commit("showVictimForm", true);
        } else {
          this.$store.commit("showVictimForm", false);
        }
        return projects;
      },
      set(value) {
        this.$store.commit("updateProject", value);
      }
    },
    intervention: {
      get() {
        let interventions = [];
        Object.entries(this.$store.state.record.synthesis.intervention).forEach(
          entry => {
            if (entry[1].isSelected) {
              interventions.push(entry[0]);
            }
          }
        );
        return interventions;
      },
      set(value) {
        this.$store.commit("updateIntervention", value);
      }
    },
    interventionVisible: {
      get() {
        return this.$store.state.record.synthesis.interventionVisible;
      },
      set(value) {
        this.$store.commit("updateInterventionVisible", value);
      }
    },
    referred: {
      get() {
        let references = [];
        this.showOtherReferrence = false;
        Object.entries(this.$store.state.record.synthesis.referred).forEach(
          entry => {
            if (entry[1].isSelected) {
              references.push(entry[0]);
              if (
                entry[0] == "estatal" ||
                entry[0] == "federal" ||
                entry[0] == "municipal" ||
                entry[0] == "segsocial" ||
                entry[0] == "ongosc" ||
                entry[0] == "procuraduria" ||
                entry[0] == "private" ||
                entry[0] == "other"
              ) {
                this.showOtherReferrence = true;
              }
            }
          }
        );

        return references;
      },
      set(value) {
        if (
          value.indexOf("estatal") === -1 &&
          value.indexOf("federal") === -1 &&
          value.indexOf("municipal") === -1 &&
          value.indexOf("segsocial") === -1 &&
          value.indexOf("ongosc") === -1 &&
          value.indexOf("procuraduria") === -1 &&
          value.indexOf("private") === -1 &&
          value.indexOf("other") === -1
        ) {
          this.$store.commit("updateOtherReferrence", "");
        }
        this.$store.commit("updateReferences", value);
      }
    },
    referredVisible: {
      get() {
        return this.$store.state.record.synthesis.referredVisible;
      },
      set(value) {
        this.$store.commit("updateReferredVisible", value);
      }
    },
    otherReferrence: {
      get() {
        return this.$store.state.record.synthesis.otherReferrence;
      },
      set(value) {
        this.$store.commit("updateOtherReferrence", value);
      }
    },
    management: {
      get() {
        return this.$store.state.record.synthesis.management;
      },
      set(value) {
        this.$store.commit("updateManagement", value);
      }
    }
  },
  methods: {
    visible(item) {
      switch (item) {
        case "country":
          this.countryVisible = !this.countryVisible;
          break;
        case "state":
          this.stateVisible = !this.stateVisible;
          break;
        case "municipality":
          this.municipalityVisible = !this.municipalityVisible;
          break;
        case "matter":
          this.matterVisible = !this.matterVisible;
          break;
        case "intervention":
          this.interventionVisible = !this.interventionVisible;
          break;
        case "referred":
          this.referredVisible = !this.referredVisible;
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.input-group.input-group--dirty.input-group--required.input-group--text-field.primary--text {
  width: 150px;
}

.upload {
  display: flex;
  align-self: center;
  cursor: pointer;
  p {
    font-size: 0.8rem !important;
  }
  &:hover {
    opacity: 0.7;
  }
}

.top-col {
  align-self: flex-start;
}

.checkbox-title p {
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.54) !important;
}

.input-group label {
  font-size: 12px !important;
}

input::placeholder {
  font-size: 12px !important;
}

.adjunct-label {
  display: flex;
  align-items: baseline;
  i {
    font-size: 15px;
  }
}

.adjunct {
  p {
    color: white;
  }
  a {
    font-weight: bold;
    color: #F1BCDF !important;
  }
}
</style>
